import { render, staticRenderFns } from "./jsfun-record.vue?vue&type=template&id=ef13b962&"
import script from "./jsfun-record.vue?vue&type=script&lang=js&"
export * from "./jsfun-record.vue?vue&type=script&lang=js&"
import style0 from "./jsfun-record.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef13b962')) {
      api.createRecord('ef13b962', component.options)
    } else {
      api.reload('ef13b962', component.options)
    }
    module.hot.accept("./jsfun-record.vue?vue&type=template&id=ef13b962&", function () {
      api.rerender('ef13b962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jsfun-record/jsfun-record.vue"
export default component.exports